var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3812 13.1217C4.3812 14.3294 3.40655 15.304 2.1989 15.304C0.991251 15.304 0.0166016 14.3261 0.0166016 13.1217C0.0166016 11.9174 0.991251 10.9395 2.1989 10.9395H4.3812V13.1217ZM5.4707 13.1217C5.4707 11.9141 6.44535 10.9395 7.653 10.9395C8.86065 10.9395 9.8353 11.9141 9.8353 13.1217V18.5759C9.8353 19.7835 8.86065 20.7581 7.653 20.7581C6.44535 20.7581 5.4707 19.7835 5.4707 18.5759V13.1217Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6528 4.36459C6.44516 4.36459 5.47051 3.38994 5.47051 2.1823C5.47051 0.97465 6.44516 0 7.6528 0C8.86045 0 9.8351 0.97465 9.8351 2.1823V4.36459H7.6528ZM7.6528 5.47051C8.86045 5.47051 9.8351 6.44516 9.8351 7.6528C9.8351 8.86045 8.86045 9.8351 7.6528 9.8351H2.1823C0.97465 9.8351 0 8.85717 0 7.6528C0 6.44844 0.97465 5.47051 2.1823 5.47051H7.6528Z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3965 7.6528C16.3965 6.44516 17.3711 5.47051 18.5788 5.47051C19.7864 5.47051 20.7611 6.44516 20.7611 7.6528C20.7611 8.86045 19.7864 9.8351 18.5788 9.8351H16.3965V7.6528ZM15.307 7.6528C15.307 8.86045 14.3323 9.8351 13.1247 9.8351C11.917 9.8351 10.9424 8.86045 10.9424 7.6528V2.1823C10.9424 0.97465 11.917 0 13.1247 0C14.3323 0 15.307 0.97465 15.307 2.1823V7.6528Z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1247 16.3936C14.3323 16.3936 15.307 17.3682 15.307 18.5759C15.307 19.7835 14.3323 20.7581 13.1247 20.7581C11.917 20.7581 10.9424 19.7835 10.9424 18.5759V16.3936H13.1247ZM13.1247 15.304C11.917 15.304 10.9424 14.3294 10.9424 13.1217C10.9424 11.9141 11.917 10.9395 13.1247 10.9395H18.5952C19.8028 10.9395 20.7775 11.9141 20.7775 13.1217C20.7775 14.3294 19.8028 15.304 18.5952 15.304H13.1247Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.1d47e5cb74ce1bd99562fa0e6adae656.svg";
export { ForwardRef as ReactComponent };